import { useEffect, useState } from 'react';
import Bugsnag from '@bugsnag/js';
import { activate, waitTillAvailable } from '@vp/ab-reader';
import { Criteria, validateAllCriteria } from '@99designs/experiments';

export function useVistaExperiment(name: string, criteria: Criteria[]) {
    const [variant, setVariant] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const shouldRunExperiment = validateAllCriteria(criteria);

    useEffect(() => {
        async function checkExperiment() {
            setIsLoading(true);

            if (!shouldRunExperiment) {
                setVariant(null);
                setIsLoading(false);
                return;
            }

            const available = await waitTillAvailable(3000);
            if (!available) {
                Bugsnag.notify(new Error('AB reader is not available'));
                setVariant(null);
                setIsLoading(false);
                return;
            }

            const activeVariant = activate(name);

            setVariant(activeVariant as string | null);
            setIsLoading(false);
        }

        void checkExperiment();
    }, [shouldRunExperiment, name]);

    return { variant, isLoading };
}
